var _style, _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle3, _path12, _polygon, _path13, _polygon2, _path14, _path15, _path16, _circle4, _path17, _circle5, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSlide3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    s3yle: "enable-background:new 0 0 160 160;",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.s30{fill:#F2F2F2;}\r\n\t.s31{fill:#CDCCCC;}\r\n\t.s32{fill:#616BB0;}\r\n\t.s33{fill:#F6B5B7;}\r\n\t.s34{fill:#A1626A;}\r\n\t.s35{fill:#403E56;}\r\n\t.s36{fill:#302F42;}\r\n\t.s37{fill:#E7E6E6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "M137.94,133.12l0.38-8.65c4.01-2.14,8.49-3.28,13.04-3.3c-6.26,5.12-5.48,14.99-9.72,21.87 c-2.72,4.33-7.25,7.19-12.33,7.77l-5.24,3.21c-1.46-8.11,0.71-16.45,5.94-22.83c1.47-1.75,3.15-3.31,5-4.65 C136.27,129.85,137.94,133.12,137.94,133.12z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "s30",
    cx: 61.91,
    cy: 48.7,
    r: 34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "s31",
    cx: 63.29,
    cy: 41.08,
    r: 11.09
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "e457262b-f043-4272-b9dd-aba1e09de7d8_00000017474194980190105190000012926399268359425930_",
    className: "s31",
    d: "M73.05,33.75 c0,0,2.89-5.52-3.46-6.02c0,0-5.41-4.91-10.93-0.9c0,0-3.01,0-4.66,3.41c0,0-2.37-0.9-2.89,1.5c0,0-1.73,5.02,0,9.53 s2.31,5.02,2.31,5.02s-1.22-5.6,5.71-6.1S72.42,35.35,73,40.87s1.21,3.03,1.21,3.03S79.69,36.01,73.05,33.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s31",
    d: "M87.29,71.3c-12.26,13.94-33.43,15.47-47.56,3.44l2.92-8.14c1.34-2.94,4.2-4.91,7.43-5.1l1.86-0.11l4.42-3.82 c0,0,11.92-0.43,11.74-0.63l7.22,4.34l-0.01-0.03l2.84,0.17c3.23,0.19,6.09,2.16,7.43,5.1L87.29,71.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "M50.47,44.72v0.01c-0.02-0.05-0.03-0.09-0.04-0.14L50.47,44.72z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "M50.47,44.73c0.03,0.13,0.07,0.26,0.11,0.39c-0.05,0.01-0.1,0.02-0.16,0.03L50.47,44.73z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "M95.9,48.63c0,18.26-14.42,33.25-32.66,33.96V14.66C81.48,15.37,95.91,30.37,95.9,48.63z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "M50.44,44.59l0.04,0.13v0.01C50.46,44.69,50.44,44.64,50.44,44.59z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "M71.82,41.99c0,0.9-0.11,1.79-0.33,2.66v0.01c-1.02,4-4.21,7.08-8.25,7.94V31.37 C68.24,32.44,71.82,36.87,71.82,41.99z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "M87.41,71.37c-6.13,7-14.87,11.16-24.17,11.52V57.36c2.65-0.12,5.06-0.26,4.98-0.35l7.22,4.34l-0.01-0.03 l2.84,0.17c3.23,0.19,6.09,2.16,7.43,5.1l1.64,4.58L87.41,71.37z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "M50.47,44.73c0.03,0.13,0.07,0.26,0.11,0.39c-0.05,0.01-0.1,0.02-0.16,0.03L50.47,44.73z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "M71.52,45.17c-0.01-0.17-0.02-0.34-0.03-0.52v-0.01c-0.04-1.2-0.21-2.39-0.52-3.55 c-0.41-1.31-1.17-2.57-2.32-3.27c-1.73-1.05-4.16-0.48-5.4,1.09v-13.1c1.18,0.31,2.3,0.8,3.32,1.46c2.86,1.85,4.94,4.69,5.86,7.97 C73.32,38.56,73,42.08,71.52,45.17z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "M62.77,92.31c-0.22,0.01-0.42-0.16-0.43-0.39V4.14c0.02-0.24,0.24-0.41,0.47-0.38c0.2,0.02,0.36,0.18,0.38,0.38 v87.79C63.19,92.15,63,92.32,62.77,92.31z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "M105.42,38.08l-11.83-2.9l-15.77-13.4l2.63-4.17l14.28,9.1c0,0,9.45,2.4,12.68,5.17L105.42,38.08z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "s33",
    cx: 78.38,
    cy: 19.15,
    r: 2.88
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "M105.98,30.33l-10.97-4.47l-5.27,6.26l3.92,3.23l10.67,2.77l0.01,0.03c0.75,2.76,5.57,4.64,9.48,5.73 c2.68,0.74,5.47-0.72,6.39-3.34l0,0c0.66-1.91,0.17-4.02-1.24-5.45l-3.55-3.56L105.98,30.33z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "s33",
    points: "75.65,142.72 71.81,141.26 75.62,125.74 81.29,127.9 "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "M77.11,141.84l-1.08-0.41l-3.57-3.32l-2.92,0.86l0,0c-2.66-1.01-5.65,0.32-6.66,2.99l-0.06,0.16l12.39,4.72 L77.11,141.84z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "s33",
    points: "114.51,149.17 110.4,149.16 108.44,133.3 114.51,133.3 "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "M115.56,147.82l-1.16,0l-4.52-1.84l-2.42,1.84h0c-2.85,0-5.16,2.31-5.16,5.16v0.17l13.26,0L115.56,147.82z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "M120.78,80.84c0,0,0.48,5.76-0.72,11.28c-0.75,3.46-1.03,10.86-1.14,15.91c-0.06,3-1.41,3.48-1.41,3.48l0.9,6.9 l-2.19,25.09l-7.92-0.72l-2.16-50.66l-14.24,11.26l0.4,1.32c0.19,0.64-1.22,0.56-1.79,0.91l0,0l-1.4,3.24 c0.06,1.1-0.58,2.11-1.59,2.55l0,0l-7.42,22.08l-5.79-3.47l1.93-20.06l2.7-9.26l10.87-13.37l0.24-3.84l1.08,0.04l0.55-1.61 l1.01-2.76L120.78,80.84z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "M121.19,82.05l0.04-0.06c2.29-3.2-1.15-10.89-1.67-12l0,0c1.27-0.41,2.07-1.66,1.92-2.99l-0.22-1.9l-0.23-1.86 l1.67-1.67l0-0.04l0.96-8.4l1.4-5.58c1.07-4.3-0.26-8.84-3.48-11.88l-3.23-3.04l-3.92-5.8h-6.33l-2.17,4.1 c-4.34,1-7.34,4.96-7.13,9.41l0.49,10.74l-1.92,13.38l0,2.42l-1,1.11c-0.73,0.81-1.04,1.93-0.82,3l0.13,0.66l0,0 c-1.03,0.44-1.79,1.36-2.02,2.46l-0.35,1.64c-0.3,0.4-2.29,3.05-2.29,3.77c0,0.11,0.08,0.21,0.25,0.33 c1.35,0.92,8.84,2.79,12.16,1.46c3.53-1.41,17.56,0.71,17.7,0.73L121.19,82.05z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "s33",
    cx: 110.45,
    cy: 16.57,
    r: 8.38
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "M107.71,53.37l-5.82,10.7L84.91,75.9l-3.36-3.6L93.99,60.8c0,0,4.73-8.53,8.23-10.95L107.71,53.37z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "s33",
    cx: 82.51,
    cy: 74.7,
    r: 2.88
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "M107.19,54.8l3.66-8.78l-1.32-4.85c-0.54-1.94-2.13-3.41-4.11-3.79l0,0c-2.73-0.5-5.39,1.2-6.08,3.89 c-1,3.94-1.77,9.05,0.25,11.08l0.02,0.02l-6.02,7.86l8.87,5.01L107.19,54.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "M118.72,10.8c-0.68-0.92-1.66-1.57-2.41-2.43c-0.38-0.5-0.78-0.98-1.21-1.44c-0.9-0.75-2.05-1.16-3.22-1.15 c-2.59-0.07-5.05,1.1-6.64,3.15c-0.61-0.36-1.22-0.71-1.83-1.07c-0.24,0.63-0.48,1.27-0.72,1.9c-0.46-0.4-1.16-0.35-1.56,0.11 c-0.31,0.36-0.36,0.87-0.13,1.28c-0.14-0.45-0.81-0.54-1.17-0.25c-0.34,0.33-0.5,0.82-0.4,1.29c0.15,1.05,0.93,1.9,1.96,2.15 c0.79,0.18,1.72-0.01,2.35,0.5c0.51,0.41,0.66,1.15,1.18,1.54c0.64,0.49,1.55,0.26,2.34,0.37c1.44,0.25,2.45,1.55,2.33,3.01 c0.1-0.45,0.28-0.87,0.54-1.25c0.27-0.38,0.75-0.56,1.21-0.47c0.73,0.22,0.84,1.21,0.67,1.94c-0.47,1.95-2.23,5.11-2.23,5.11 c2.3,0.91,5.03,0.05,6.8-1.67c1.77-1.72,2.69-4.15,3.1-6.59C120.02,14.76,119.97,12.48,118.72,10.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "s31",
    d: "M155.56,153.47c0,0.25-0.2,0.46-0.46,0.46c0,0,0,0,0,0H4.98c-0.25,0-0.46-0.21-0.46-0.46s0.21-0.46,0.46-0.46 H155.1C155.35,153.01,155.56,153.21,155.56,153.47C155.56,153.47,155.56,153.47,155.56,153.47z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSlide3);
export default __webpack_public_path__ + "static/media/home-slide-3.0bf7d3807d147de5416b3f07241f35e5.svg";
export { ForwardRef as ReactComponent };